import React, { useEffect, useRef, useState } from 'react';
import { Col } from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import { toast } from "react-toastify";
import _ from 'lodash';

export default function LocalNumberFormatWrapper({ onChange, testInfo, onChangeString, readOnlyPRP, allowZeroPRP = true, padding = 0, min, max }) {
   const firstRender = useRef(true);
   const [error, setError] = useState(true);
   const [value, setValue] = useState(testInfo[onChangeString]);
   const inputClassName = error ? '' : 'error-input';
   const readOnly = (readOnlyPRP === null || readOnlyPRP === undefined) ? false : !readOnlyPRP;
   if (onChangeString === "numEnds") setValue(value < 1 ? 1 : value);

   useEffect(() => {
      if (firstRender) {
         setValue(_.toNumber(value).toFixed(padding));
         handleBlur();
      } else {
         firstRender.current = false;
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   const handleBlur = () => {
      let value = testInfo[onChangeString];
      if (_.isNil(min) || _.isNil(max) || _.isNil(padding)) return;
      if (typeof value != "number") value = _.toNumber(value);
      if (typeof min != "number") min = _.toNumber(value);
      if (typeof max != "number") max = _.toNumber(value);
      setError(_.toNumber(value) >= min && _.toNumber(value) <= max);
      const paddedNumber = _.toNumber(value).toFixed(padding);
      setValue(paddedNumber);
   };

   const onChangeRegexFormat = (paragraph, propertyName) => {
      if (typeof paragraph != "string") return 0;
      const regex = /[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)/;
      const found = paragraph.match(regex);
      if (found != null) {
         let value = parseFloat(found[0]);
         onChange(propertyName, value);
      } else {
         toast.warning(`your number ${paragraph} is not formatted correctly please try again`);
      }
   };

   return (
      <Col xs="12">
         <DebounceInput
            style={{ textAlign: "right" }}
            key={onChangeString}
            element={"input"}
            className={`form-control ${inputClassName}`}
            value={!allowZeroPRP && !value && readOnly ? "N/A" : value}
            onChange={(e) => onChangeRegexFormat(e.target.value, onChangeString)}
            readOnly={readOnly}
            debounceTimeout={350}
            disabled={readOnly}
            placeholder={"N/A"}
            onBlur={handleBlur}
         />
      </Col>
   );
}